import { handlePreview } from '@/components/Common/PreviewImage';
import { CatalogCompany } from '@/shared/types/catalog';
import { isEmpty, take, uniq } from 'lodash-es';
import React from 'react';
import './index.less';
import Image from 'next/image';

interface IProps {
  supplier: CatalogCompany;
}

const NotablePastProjects = ({ supplier }: IProps) => {
  const notableWorks = supplier?.notableWorks ?? [];
  const portfolio: string[] = supplier?.portfolio ?? [];
  const portfolioToShow = uniq(take(portfolio, 6));

  return (
    <div className="notable-past-projects">
      {!isEmpty(notableWorks) && (
        <div className="header">
          <h2 className="title">Notable past projects & clients</h2>
          <span className="description">{notableWorks}</span>
        </div>
      )}

      <div className="photos">
        {portfolioToShow.map((photo: string, i: number) => (
          <Image
            className="photo"
            key={`grid-${photo}`}
            src={photo}
            alt={supplier.name + ' portfolio' + i}
            width={108}
            height={100}
            sizes="(min-width: 800px) 225px, 108px"
            onClick={() => {
              handlePreview({ urls: portfolioToShow, current: i });
            }}
            loading="lazy"
          />
        ))}
      </div>
    </div>
  );
};

export default NotablePastProjects;
